module.exports = __webpack_public_path__ + "assets/0f58cf69672aa0fbfb87c4098f852e68-DSC_0803.jpg";